import { ArrowUp } from 'lucide-react';
import { useSubscription } from '@rta/rta-blueprint-library';

import { ContentPanelMode, selectContentPanelMode, useAppSelector } from '@state';
import { Controller } from '@context';
import { ControllerFontSizeSupport } from './types';
import { Feature, FeatureHoookParams } from '..';
import { lang } from '@lang';
import { useDesign } from '@hooks';

type IncreaseFontSizeFeatureParams = FeatureHoookParams;
export const useIncreaseFontSizeFeature = (_params: IncreaseFontSizeFeatureParams = {}): Feature<number> => {
	const [controller] = useDesign<Controller, ControllerFontSizeSupport>();
	const contentMode: ContentPanelMode = useAppSelector(selectContentPanelMode);

	useSubscription(controller, false, [['designer-options-adjust-font-size', 'updated']]);

	const controllerSupportsFontSizeFeature = (controller?.options?.dimensions?.fontSizeFactor ?? null) !== null;
	const inThreeD = contentMode === ContentPanelMode.ThreeD;

	const font = controller && controllerSupportsFontSizeFeature ? controller.options.dimensions.fontSizeFactor : 0;

	return {
		name: 'increaseFontSize',
		label: lang.fontSize.label.increase,
		shortcut: '',
		tooltip: inThreeD ? lang.fontSize.tooltip.disabledInThreeDView : lang.fontSize.tooltip.increase,
		icon: (props = {}) => <ArrowUp {...props} />,
		disabled: inThreeD || !controllerSupportsFontSizeFeature,
		value: font ?? 0,
		hidden: false,
		handler: () => {
			if (!inThreeD && controller && controllerSupportsFontSizeFeature) controller.options.dimensionFontSizeFactor += 0.1;
		}
	};
};
